import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { NOTIFICATION } from 'src/app/constants/endpoint.const';
import { BypassInterceptorContext } from 'src/app/interceptors/http.interceptor';
import { NotificationModel } from 'src/app/models/notifications.model';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-modal-banner-notif',
  standalone: false,
  templateUrl: './modal-banner-notif.component.html',
  styleUrl: './modal-banner-notif.component.scss',
})
export class ModalBannerNotifComponent {
  @Input() isVisibleBanner = false;
  @Output() isVisibleBannerEvent = new EventEmitter<boolean>();
  destroy$ = new Subject<void>();
  notifications: NotificationModel[] = [];
  currentIndex = 0;

  get currentNotification() {
    return this.notifications[this.currentIndex];
  }

  constructor(
    private httpClient: HttpClient,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.notificationService.getBanners().subscribe((data) => {
      // Filter banner yang belum pernah ditutup jika one-time
      const dismissed = JSON.parse(localStorage.getItem('dismissedOneTimeBanners') || '[]');
      this.notifications = data.filter((notif) => 
        notif.is_recurring || !dismissed.includes(notif.id)
      );

      if (this.notifications.length > 0) {
        this.isVisibleBanner = true;
      }
    });
  }

  handleCancel(): void {
    const notif = this.notifications[this.currentIndex];
    if (!notif) return;

    if (!notif.is_recurring) {
      const dismissed = JSON.parse(localStorage.getItem('dismissedOneTimeBanners') || '[]');
      if (!dismissed.includes(notif.id)) {
        dismissed.push(notif.id);
        localStorage.setItem('dismissedOneTimeBanners', JSON.stringify(dismissed));
      }
    }

    this.currentIndex++;
    if (this.currentIndex < this.notifications.length) {
      this.isVisibleBanner = true;
    } else {
      this.isVisibleBanner = false;
      this.isVisibleBannerEvent.emit(false); // Beri tahu parent jika perlu
    }
  }
}

